import Link from 'next/link'
import { n_landing } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import urls from '../../../../modules/urls'

const InquiryButtons = ({ onClick }) => {
  const { t } = useTranslation()

  return (
    <section className="flex sm:gap-x-20 gap-y-24 flex-col sm:flex-row">
      <div className="sm:w-[27%] flex flex-col gap-y-44">
        <div className="flex flex-col gap-y-10">
          <div className="flex gap-x-8">
            <Link
              className="p-12 w-[112px] bg-white Body2-14Md border rounded-[7px] text-center"
              target="_blank"
              href={'https://pf.kakao.com/_sYFgV/chat'}
              onClick={() => onClick('카카오톡 문의', null)}
            >
              {t(n_landing.footer.btn_1)}
            </Link>
            <button
              className="p-12 w-[112px] bg-white Body2-14Md border rounded-[7px]"
              onClick={() => onClick('자주 묻는 질문', urls.student.landing.faq)}
            >
              {t(n_landing.footer.btn_2)}
            </button>
          </div>
          <span className="Body2-14Md text-gray-500">{t(n_landing.footer.desc_1)}</span>
        </div>
      </div>
      <div className="sm:w-1/5">
        <div className="flex flex-col gap-y-10">
          <Link
            className="p-12 w-[112px] bg-white Body2-14Md border rounded-[7px] text-center"
            target="_blank"
            href={'https://pf.kakao.com/_SKVxexj/chat'}
            onClick={() => onClick('틴즈 카카오톡 문의', null)}
          >
            {t(n_landing.footer.btn_3)}
          </Link>
          <span className="Body2-14Md text-gray-500">{t(n_landing.footer.desc_2)}</span>
        </div>
      </div>
      <div className="flex flex-col gap-y-10">
        <button
          className="p-12 w-[112px] bg-white Body2-14Md border rounded-[7px]"
          onClick={() => onClick('기업도입문의', '/student/adv/archive/b2b-old#inquiry')}
        >
          {t(n_landing.footer.btn_4)}
        </button>
        <span className="Body2-14Md text-gray-500">{t(n_landing.footer.desc_3)}</span>
      </div>
    </section>
  )
}

export default InquiryButtons
